import {Component, Input} from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-line-dash-array-view',
  templateUrl: './line-dash-array-view.component.html',
  styleUrls: ['./line-dash-array-view.component.scss'],
  imports: [NgStyle],
})
export class LineDashArrayViewComponent {
  @Input() color = 'grey';
  @Input() gapColor = 'transparent';
  @Input() dashArray: number[];

  protected readonly Math = Math;

  getDashArrayPixelLength(dashArray: number[]) {
    return dashArray.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
  }
}
